import { UnorderedListOutlined } from '@ant-design/icons';
import React from 'react';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { ItemRangeRule } from '../../../../rules/repository/item-range/ItemRange.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { tran } from '../../../../translations/schema/TranslationSchema';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema';
import { IMultiSelectWidget } from './IMultiSelectWidget';
import {
  MultiSelectConfigComponent,
  multiSelectInputConfigValidator,
} from './MultiSelectConfigComponent';
import { MultiSelectWidgetComponent } from './MultiSelectWidgetComponent';
import { getMultiSelectOptionsWidgetSchema } from './MultiSelectWidgetSchema';
import { MultiSelectOption } from './components/MultiSelectOption';
import {
  getMultiSelectWidgetOptionsReferences,
  getMultiSelectWidgetReference,
} from './getMultiSelectWidgetReference';

/**
 * Tipo del componente di input di testo.
 */
export const MultiSelectWidgetType: IWidgetType<IMultiSelectWidget> = {
  type: WidgetType.MultiSelect,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo scelta multipla',
  icon: <UnorderedListOutlined />,
  getReference: getMultiSelectWidgetReference,
  getSiblingReferences: getMultiSelectWidgetOptionsReferences,
  hasValue: true,
  formComponent: MultiSelectWidgetComponent,
  createFormSchema: ({ widget }) => getMultiSelectOptionsWidgetSchema(widget),
  previewComponent: MultiSelectWidgetComponent,
  optionComponent: MultiSelectOption,
  configValidator: multiSelectInputConfigValidator,
  configComponent: MultiSelectConfigComponent,
  translationSchema: tran.widget({
    ...InputCommonTranslationSchema.objectShape,
    options: OptionsTranslationSchema,
  }),
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [RequiredRule, ItemRangeRule, CustomWarningsRule],
};
